import { Backdrop, Box, Button } from '@mui/material'
import React from 'react'
import { SnakeLoader } from '../../../../../../core/loader/SnakeLoader'

export const Action = ({listData, cancelHandler, proceedHandler}) => {

	return (
		<Box>
			<Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: 3503 }} open={listData.data.action.modal}>
				<Box display="flex" flexDirection="column" bgcolor="#fff" borderRadius={3} width={343} p={2} height={180}>
					<Box fontSize={20} fontWeight={600}>{listData.data.action.type === 2 ? 'Post' : listData.data.action.type === 3 ? 'Disable' : 'Enable'} this Promo?</Box>
					{listData.data.action.type === 2 &&
						<Box>
							<Box color="#008000" mt={1} fontSize={14} fontWeight={500}>You cannot edit this page once it is posted.</Box>
							<Box color="#008000" fontSize={14} fontWeight={500}>This will be available online.</Box>
						</Box>

					}
					{listData.data.action.type === 3 &&
						<Box color="#008000" mt={1} fontSize={14} fontWeight={500}>This will not be available online.</Box>
					}
					<Box my={1} fontSize={13} fontWeight={550}>{listData.data.action.selected !== null && listData.data.action.selected.promo_name}</Box>
					<Box display="flex" gap="8px" mt="auto">
						<Box component={Button} disabled={listData.data.action.confirmed} bgcolor="#E5F2EC" color="#009F4D" fontSize={14} fontWeight={600} border="1px solid #009F4D" width="50%" borderRadius="6px" onClick={cancelHandler}
							sx={{ ':hover': { color: '#009F4D', bgcolor: '#E5F2EC' } }}
						>
							Cancel
						</Box>
						<Box component={Button} bgcolor="#009F4D" color="#fff" fontSize={14} fontWeight={600} width="50%" borderRadius="6px" onClick={proceedHandler}
							sx={{ ':hover': { color: '#fff', bgcolor: '#009F4D' } }}
						>
							{!listData.data.action.confirmed ? listData.data.action.type === 2 ? 'Post' : listData.data.action.type === 3 ? 'Disable' : 'Enable' : <Box display="flex" alignItems="center">{listData.data.action.type === 2 ? 'Post' : listData.data.action.type === 3 ? 'Disable' : 'Enable'} <SnakeLoader size="5px" bg="#fff" distance="2.5px" /></Box>}
						</Box>
					</Box>
				</Box>
			</Backdrop>
		</Box>
	)
}
